import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import StudentResponses from 'legacy/src/components/assessment/Results/shared/StudentResponses';
import StudentResponsesModal from 'legacy/src/components/assessment/Results/StudentResponses/components/StudentResponsesModal';
import { getPartByDomQuestion } from '../components/utils';
import './styles.scss';

/**
 * Draws student responses
 * */
const StudentContainer = (props) => {
  const {
    assignment: { title, questions },
    router,
    params,
    userData: {
      me: { initId: studentId, isStudent },
    },
    onModalClosePath,
    usePartsOnChangeEvent,
  } = props;
  const { subject, assignmentId, questionId } = params;

  const onClose = () => {
    const { children = [] } =
      questions.find(({ id }) => id === questionId) || {};
    let pathname =
      onModalClosePath ||
      `/${subject}/assessments/results/${assignmentId}/performance/${questionId}`;
    /**
     * It has parts
     * */
    if (children.length > 0 && usePartsOnChangeEvent) {
      const currentPart = getPartByDomQuestion(questionId, children);
      if (currentPart) {
        pathname += `/parts/${currentPart.id}`;
      }
    }

    router.push(pathname);
  };

  const modalHeader = (
    <div className="StudentResponsesModal--header">
      <h3>{title}</h3>
    </div>
  );

  const customParams = {
    ...params,
    studentId,
  };

  return (
    <StudentResponsesModal
      modalTitle={title}
      modalHeader={modalHeader}
      onClose={onClose}
    >
      <StudentResponses
        {...props}
        isStudent={isStudent}
        params={customParams}
        studentId={studentId}
        onClose={onClose}
      />
    </StudentResponsesModal>
  );
};

StudentContainer.displayName = 'StudentContainer';

StudentContainer.propTypes = {
  assignment: PropTypes.object.isRequired,
  onModalClosePath: PropTypes.string,
};

StudentContainer.defaultProps = {
  assignment: {},
  onModalClosePath: null,
};

const mapStateToProps = ({ userData }) => ({
  userData,
});

export default connect(mapStateToProps)(StudentContainer);
